var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    clipPath: "url(#clip0_0_8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8086 5.69152C11.1522 5.03511 10.2619 4.66635 9.33352 4.66635C8.40519 4.66635 7.51488 5.03511 6.85845 5.69152C6.20202 6.34792 5.83324 7.2382 5.83324 8.16649V12.25H8.16676V8.16649C8.16676 7.85706 8.28969 7.5603 8.5085 7.3415C8.72731 7.1227 9.02408 6.99978 9.33352 6.99978C9.64296 6.99978 9.93973 7.1227 10.1585 7.3415C10.3774 7.5603 10.5003 7.85706 10.5003 8.16649V12.25H12.8338V8.16649C12.8338 7.2382 12.465 6.34792 11.8086 5.69152Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49972 5.24971H1.1662V12.25H3.49972V5.24971Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33296 3.49963C2.97734 3.49963 3.49972 2.97728 3.49972 2.33292C3.49972 1.68856 2.97734 1.1662 2.33296 1.1662C1.68858 1.1662 1.1662 1.68856 1.1662 2.33292C1.1662 2.97728 1.68858 3.49963 2.33296 3.49963Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.ed8d97e43504ab05e607e11a73e2b615.svg";
export { ForwardRef as ReactComponent };